import { render, staticRenderFns } from "./FiveModalReceive.vue?vue&type=template&id=70123178&scoped=true"
import script from "./FiveModalReceive.vue?vue&type=script&lang=js"
export * from "./FiveModalReceive.vue?vue&type=script&lang=js"
import style0 from "./FiveModalReceive.vue?vue&type=style&index=0&id=70123178&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70123178",
  null
  
)

export default component.exports